module.exports = __webpack_public_path__ + "static/media/Imaryuk1.456e58ed.jpg";